import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { FiEdit, FiPlus, FiSearch, FiTrash2 } from "react-icons/fi";
import { GiBookmark } from "react-icons/gi";

import { TableContextProvider } from "./../../store/table-context";
import { confirm, modalError, modalSuccess } from "../../services/notifications";
import { actions, hasPermission } from "../../services/security";

import Card from "./../../Components/ui/card"
import Header from "../../Components/ui/header";
import Filters from "../../Components/ui/filters";
import Table from "../../Components/ui/table";
import { BASEURL } from "../../services/url";
import http from "../../services/http";

const DiccionarioPage = () => {
  let navigate = useNavigate();

  const title = "Diccionario";
  const icon = <GiBookmark />;
  const breadcrumb = [{ title: "Diccionario", url: "/diccionario" }];


  const [filters, setFilters] = useState([
    {
      type: "input",
      label: "Nombre",
      name: "nombre",
    },
    {
      type: "select",
      label: "Tipo De Campo",
      name: "tipoDeCampo",
      values: [],
    },
    {
      type: "select",
      label: "Tipo De Entrada",
      name: "tipoDeEntrada",
      values: [],
    },
    {
      type: "select",
      label: "Formato De Entrada",
      name: "formatoDeEntrada",
      values: [],
    },
    // {
    //   type: "select",
    //   label: "Banco",
    //   name: "codBanco",
    //   values: [],
    //   //initialValue: localStorage.getItem("banco") === "COR" ? null : localStorage.getItem("banco"),
    // }

  ]);

  const columns = [
    { title: "Nombre", property: "nombre", sortable: true },
    { title: "Tipo De Campo", property: "tipoDeCampo", sortable: true },
    { title: "Tipo De Entrada", property: "tipoDeEntrada", sortable: true },
    { title: "Formato De Entrada", property: "formatoDeEntrada", sortable: false },
    { title: "Cantidad Filas", property: "cantidadFilas", sortable: false },
    { title: "Caracter De Relleno", property: "caracterDeRelleno", sortable: false },
    { title: "Descripción", property: "descripcion", sortable: false },
    { title: "Longitud", property: "longitud", sortable: false },
    { title: "Valor Por Defecto", property: "valorPorDefecto", sortable: false },
  ];

  const menuSearch = [
    {
      key: "1",
      icon: <FiSearch />,
      label: "Ver",
    }
  ]

  const menuEdit = [
    {
      key: "1",
      icon: <FiEdit />,
      label: "Editar",
    }
  ]

  const menuDelete = [
    {
      key: "2",
      icon: <FiTrash2 />,
      label: "Eliminar",
    }
  ]

  const menu = (item) => (
    <div>
      {!hasPermission(actions.DiccionarioEditar) && (
        <Menu items={menuSearch} onClick={() => onClickEdit(item)} />
      )}

      {hasPermission(actions.DiccionarioEditar) && (
        <Menu items={menuEdit} onClick={() => onClickEdit(item)} />
      )}


      {hasPermission(actions.DiccionarioEliminar) && (
        <Menu items={menuDelete} onClick={() => onClickDelete(item)} />
      )}
    </div>
  );

  useEffect(() => {
    async function getTipoCampo() {
      let response = await http.get(`${BASEURL}/Parametry/TipoCampo`);

      if (response) {
        let data = response.data;
        data = data.map((item) => {
          return {
            value: item.id,
            text: item.nombre,
          };
        });

        setFilters((prevFilters) => {
          return prevFilters.map((filter) => {
            if (filter.name === "tipoDeCampo") {
              return {
                ...filter,
                values: data,
              };
            }
            return filter;
          });
        });
      }

      response = await http.get(`${BASEURL}/Parametry/TipoEntrada`);

      if (response) {
        let data = response.data;
        data = data.map((item) => {
          return {
            value: item.id,
            text: item.nombre,
          };
        });

        setFilters((prevFilters) => {
          return prevFilters.map((filter) => {
            if (filter.name === "tipoDeEntrada") {
              return {
                ...filter,
                values: data,
              };
            }
            return filter;
          });
        });
      }

      response = await http.get(`${BASEURL}/Parametry/FormatoEntrada`);

      if (response) {
        let data = response.data;
        data = data.map((item) => {
          return {
            value: item.id,
            text: item.nombre,
          };
        });

        setFilters((prevFilters) => {
          return prevFilters.map((filter) => {
            if (filter.name === "formatoDeEntrada") {
              return {
                ...filter,
                values: data,
              };
            }
            return filter;
          });
        });
      }


      // response = await http.get(`${BASEURL}/Diccionario/CodBanco`);

      // let cod = localStorage.getItem("banco");

      // if (response) {
      //   let data = response.data;
      //   data = data.map((item) => {
      //     return {
      //       value: item.id,
      //       text: item.codBanco,
      //     };
      //   });

      //   // Filtrar los codBancos según las condiciones requeridas
      //   if (cod === "COR") {
      //     // Si el cod es igual a "COR", enviar todos los codBancos
      //     setFilters((prevFilters) => {
      //       return prevFilters.map((filter) => {
      //         if (filter.name === "codBanco") {
      //           return {
      //             ...filter,
      //             values: data,
      //           };
      //         }
      //         return filter;
      //       });
      //     });
      //   } else {
      //     // Filtrar los codBancos según el valor de cod
      //     const filteredData = data.filter((item) => {
      //       return item.text === cod || item.text === "COR";
      //     });

      //     setFilters((prevFilters) => {
      //       return prevFilters.map((filter) => {
      //         if (filter.name === "codBanco") {
      //           return {
      //             ...filter,
      //             values: filteredData,
      //           };
      //         }
      //         return filter;
      //       });
      //     });
      //   }
      // }


    }
    getTipoCampo();

  }, []);


  const onClickAdd = () => {
    navigate("/diccionario/nuevo");
  };

  const onClickEdit = (item) => {
    navigate(`/diccionario/${item.id}`);
  };

  const onClickDelete = async (item) => {

    const confirmed = await confirm(
      "Eliminar diccionario",
      `¿Esta seguro que desea eliminar el diccionario ${item.nombre}?`
    );

    if (!confirmed) {
      return;
    }

    const response = await http.delete(`${BASEURL}/Diccionario/${item.id}`)
      .catch((error) => {
        if (error.response) {
          modalError(
            error.response.data.errores[0].titulo,
            error.response.data.errores[0].detalle,
          )
        }
      })
    if (response) {

      await modalSuccess(
        "Diccionario eliminado",
        "El diccionario fue eliminado exitosamente"
      );
      navigate(0)
    }
  };

  const buttons = [
    {
      title: "Agregar ",
      text: <FiPlus />,
      type: "primary",
      onClick: onClickAdd,
      visible: hasPermission(actions.DiccionarioCrear),
    },
  ];



  return (
    <TableContextProvider>
      <Card>
        <Header
          title={title}
          icon={icon}
          breadcrumb={breadcrumb}
          showFilters
          buttons={buttons}
        />
        <Filters fields={filters} />
        <Table
          id="table-diccionario"
          columns={columns}
          menu={menu}
          url="/Diccionario"
          orderBy="nombre"
          orderDirection="ascending"
          codBNC={localStorage.getItem("banco") === "COR" ? null : localStorage.getItem("banco")}
        />
      </Card>
    </TableContextProvider>
  );
};

export default DiccionarioPage;
